
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import _Link from 'next/link'
import { Heading as _Heading } from '@/components/Heading'
const meta = {};
const slug = '_advancedfeatures';
const tableOfContents = [{
  "title": "------",
  "slug": "",
  "children": [{
    "title": "Product Collection",
    "slug": "product-collection",
    "children": []
  }, {
    "title": "Taxes (Advanced)",
    "slug": "taxes-advanced",
    "children": []
  }, {
    "title": "Product Types",
    "slug": "product-types",
    "children": []
  }, {
    "title": "Advanced Rules",
    "slug": "advanced-rules",
    "children": []
  }, {
    "title": "Custom Fields (Attributes) for Product descriptions & Filters",
    "slug": "custom-fields-attributes-for-product-descriptions-and-filters",
    "children": []
  }, {
    "title": "Monitoring Business",
    "slug": "monitoring-business",
    "children": []
  }]
}];

const layoutProps = {
  meta,
slug,
tableOfContents
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <_Heading level={2} id={""} nextElement={{
      "type": "heading",
      "depth": 3
    }}>------</_Heading>
    <_Heading level={3} id={"product-collection"} nextElement={{
      "type": "paragraph"
    }}>Product Collection</_Heading>
    <p>{`Organise your products into collections (Thematic, promotional, season etc) `}</p>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/collection.png" />
    </div>
    <_Heading level={3} id={"taxes-advanced"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Taxes (Advanced)</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Discounts`}</li>
      <li parentName="ul">{`Mini-tools (QR Code Generator, Barcode Generator, Short Link generator, UTM Generator) `}</li>
    </ul>
    <_Heading level={3} id={"product-types"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Product Types</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Items with Variances`}</li>
      <li parentName="ul">{`Items with Bundles
Read more about Variation Here. `}</li>
    </ul>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/variants1.png" />
    </div>
    <_Heading level={3} id={"advanced-rules"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Advanced Rules</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Limit number of items purchased on platform level (Stocks, Ticket Limits)`}</li>
      <li parentName="ul">{`Limit number of items purchased per user `}</li>
      <li parentName="ul">{`Limit Minimum Price, Minimum Quantity, Maximum Quantity `}</li>
      <li parentName="ul">{`Limit minimum total order size on Payment method level `}</li>
    </ul>
    <p>{`Read more about how to use this rules here`}</p>
    <p>{`Learn more about shipping methods. `}</p>
    <_Heading level={3} id={"custom-fields-attributes-for-product-descriptions-and-filters"} nextElement={{
      "type": "paragraph"
    }}>Custom Fields (Attributes) for Product descriptions & Filters</_Heading>
    <p>{`You can easily add custom fields for your product adding page. And it can be customised to be shown on listing category level. `}</p>
    <div class="relative">
        <img class="w-full  h-82 object-cover rounded-lg shadow-lg" src="/img/attributes2.png" />
    </div>
    <p><_Link href="/docs/attributes" passHref><a>{`Learn more about here`}</a></_Link></p>
    <_Heading level={3} id={"monitoring-business"} nextElement={{
      "type": "list",
      "ordered": false,
      "start": null,
      "spread": false
    }}>Monitoring Business</_Heading>
    <ul {...{
      "role": "list"
    }}>
      <li parentName="ul">{`Inventory report`}</li>
      <li parentName="ul">{`Sales report`}</li>
    </ul>



    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
MDXContent.layoutProps = layoutProps
